import React, {
  Dispatch,
  SetStateAction,
  useEffect,
  useRef,
  useState
} from 'react';
import { IComponentCarousel } from '../../component.d';
import './AllForCarousel.scss';
import { createPortal } from 'react-dom';
import FlipCard from './effects/FlipCard';
import CommonEffect from './effects/CommonEffect';
import { inject, observer } from 'mobx-react';
import RootStore from '../../store/RootStore';
import { IOneGalleryBase } from '../GalleryList/Common';
import imageUtil from '../../utils/image';
import { getWatermarks } from '../../utils/util';
import useCarousel from './useCarousel';
import CarouselControlBtns from './CarouselControlBtns';
import useImageList from './useImageList';
import AllForDanmuku from '../Danmuku/AllForDanmuku';
import QrCode from "qrcode";
import wxUtil from '../../utils/wx';

const { getShareUrl } = wxUtil;

let qrCodes = {} as { [key: string]: string }; // 缓存
const getQrCode = async function (url: string) {
  if (qrCodes[url]) {
    return qrCodes[url];
  }
  const dataUrl = await QrCode.toDataURL(url, { margin: 2 });
  qrCodes[url] = dataUrl;
  return dataUrl;
};

const useQrCode = function (url: string) {
  const [dataUrl, setDataUrl] = useState("");
  useEffect(() => {
    getQrCode(url).then((data) => setDataUrl(data));
  }, [url]);
  return dataUrl;
};

export interface ICarouselConfig {
  time: number;
  order: string;
  effect: string;
  danmuku: number;
  qrcode: number;
}

export interface ICarouselProp {
  config: ICarouselConfig;
  images: IOneGalleryBase[];
  loadMore?: () => void;
  index: number; //当前图片下标
  setIndex: Dispatch<SetStateAction<number>>; // 设置当前下标
  watermarks?: any[];
}

export const RenderEffect = function (props: ICarouselProp) {
  switch (props.config.effect) {
    // case 'image-fade':
    //   return <CommonEffect  {...props} />;
    case 'flip-card': // 还没实现
      return <FlipCard {...props} />;
    default:
      return <CommonEffect {...props} />;
  }
};

interface IAllForCarousel extends IComponentCarousel {
  rootStore?: RootStore;
}

const AllForCarousel = function (props: IAllForCarousel) {
  const { gallery_list, rootStore } = props;

  useEffect(() => {
    if (gallery_list && gallery_list.length) {
      rootStore?.pagedataStore.getGallerys(gallery_list);
    }
  }, [gallery_list]);

  const { list: imageList, loadMore } = useImageList({
    rootStore,
    gallery_list,
    currentIndex: 0
  });
  const [index, setIndex] = useState(0);

  const {
    start,
    config,
    finalList,
    opShow,
    setTheConfig,
    list,
    toPlay,
    toPause,
  } = useCarousel({
    rootStore,
    list: imageList,
    loadMore,
    index,
    setIndex
  });

  const checkCurrentWatermark = () => {
    const image = list[index];
    if (image && typeof image.show_mark === 'number') {
      if (image.show_mark === 1) {
        const imageSpecialGalleryWatermark = rootStore?.galleryStore.getWatermarksByKey(image.galleryid);
        return imageSpecialGalleryWatermark || getWatermarks();
      }
      return [];
    } else {
      return [];
    }
  };

  const qrcodeDataUrl = useQrCode(getShareUrl(true));

  const currentWatermark = checkCurrentWatermark();

  return createPortal(
    <div className="all-for-carousel">
      {start ? (
        <RenderEffect
          config={config}
          images={finalList}
          index={index}
          setIndex={setIndex}
          watermarks={currentWatermark}
        />
      ) : (
        <>
          <div
            className={'bg'}
            style={{
              backgroundImage: `url(${imageUtil.style(
                list[index]?.hash,
                'wx_1920_n', // 保持和大图页一致
                { watermark: currentWatermark },
                list[index]?.id
              )})`
            }}
          />

          {/*<img
            className={'slider-play'}
            src={require('../../assets/slider-play.png')}
            onClick={toPlay}
            alt=""
          />*/}
        </>
      )}
      {Number(config.qrcode) ? <div className="gallery-qrcode right-center">
        <img src={qrcodeDataUrl} className="gallery-qrcode-wrapper" />
        <p>扫码观看照片直播</p>
      </div> : null}
      {opShow && (
        <>
          <div className={'bottom'}>
            <CarouselControlBtns config={config} setTheConfig={setTheConfig} onStart={toPlay} onPause={toPause} isPlaying={start} />
          </div>
        </>
      )}
      <div className="danmuku-wrapper">
        <AllForDanmuku enable={Number(config.danmuku) > 0} />
      </div>
    </div>,
    document.body
  );
};

export default inject('rootStore')(observer(AllForCarousel));
